export default function ConfirmModal({ title, message, onConfirm, onCancel, confirmLabel = "Confirmer", danger = false }) {
  return (
    <div className="modal-overlay" onClick={onCancel}>
      <div className="sheet" onClick={e => e.stopPropagation()} style={{ maxWidth: 400 }}>
        <div style={{ padding: "24px 22px" }}>
          <div style={{ fontSize: 18, fontFamily: "'DM Serif Display',serif", color: "#E8E2D8", marginBottom: 10 }}>{title}</div>
          {message && <div style={{ fontSize: 13, color: "#7A7468", lineHeight: 1.6, marginBottom: 24 }}>{message}</div>}
          <div style={{ display: "flex", gap: 10 }}>
            <button
              onClick={onCancel}
              className="btn"
              style={{ flex: 1, padding: 13, borderRadius: 10, border: "1px solid #2A2924", fontSize: 14, color: "#7A7468", fontWeight: 500 }}>
              Annuler
            </button>
            <button
              onClick={onConfirm}
              className="btn"
              style={{ flex: 1, padding: 13, borderRadius: 10, border: "none", fontSize: 14, fontWeight: 600, background: danger ? "#FC818120" : "#C9A96E", color: danger ? "#FC8181" : "#0F0E0C", border: danger ? "1px solid #FC818140" : "none" }}>
              {confirmLabel}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
